// extracted by mini-css-extract-plugin
export default {"ripple":"Ripple_ripple__+vi87","ripple-big":"Ripple_ripple-big__D5gvw","ripple-md":"Ripple_ripple-md__6eoxu","ripple-sm":"Ripple_ripple-sm__5mibH"};